// extracted by mini-css-extract-plugin
module.exports = {"component":"styles__component--3xzz9"};